<div class="relative min-h-full w-full">
<!-- Top view toggle -->
<div class="flex justify-center items-center mb-4 shrink-0 bg-white dark:bg-slate-800 rounded-xl p-2 shadow-sm w-full min-h-[5rem]">
  <div
    class="inline-flex items-center p-1 rounded-xl bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 max-h-[2.5rem]">
    <button type="button" (click)="activeCrmView.set('LIVE_MONITORING')"
      class="flex items-center gap-2 px-4 py-1 rounded-xl text-sm font-bold transition-all cursor-pointer border"
      [ngClass]="activeCrmView() === 'LIVE_MONITORING'
              ? 'bg-[#A446FF] text-white border-[#A446FF]/50 dark:border-[#A446FF]/20 shadow-sm'
              : 'bg-transparent text-slate-600 dark:text-slate-400 border-transparent hover:text-slate-800'">
      <span class="w-2 h-2 rounded-xl shrink-0"
        [ngClass]="activeCrmView() === 'LIVE_MONITORING' ? 'bg-red-400' : 'bg-red-500 animate-pulse'"></span>
      Live Monitoring
      @if (ongoingCallsCount() > 0) {
      <span class="min-w-[20px] h-5 px-1.5 rounded-xl text-[11px] font-bold flex items-center justify-center"
        [ngClass]="activeCrmView() === 'LIVE_MONITORING' ? 'bg-white/25 text-white' : 'bg-purple-100 text-[#A446FF] dark:bg-purple-900/40 dark:text-purple-300'">
        {{ ongoingCallsCount() }}
      </span>
      }
    </button>
    <button type="button" (click)="activeCrmView.set('CALL_HISTORY')"
      class="flex items-center gap-2 px-4 py-1 rounded-xl text-sm font-bold transition-all cursor-pointer" [ngClass]="activeCrmView() === 'CALL_HISTORY'
              ? 'bg-[#A446FF] text-white border-[#A446FF]/50 dark:border-[#A446FF]/20 shadow-sm'
              : 'text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
      <app-icon-v2 name="history" [size]="16"
        [customClass]="activeCrmView() === 'CALL_HISTORY' ? 'text-white' : 'text-slate-500'" />
      Call History &amp; Audit
    </button>
  </div>
</div>
<div class="relative bg-white dark:bg-slate-900 font-sans text-slate-800 dark:text-slate-200 rounded-xl shadow-sm">
  <div class="max-w-[1800px] mx-auto p-4 md:p-6">

    @if (activeCrmView() === 'LIVE_MONITORING') {
    <app-live-monitoring [productPid]="sidebarProductPid()"
      (ongoingCountChange)="ongoingCallsCount.set($event)" />
    } @else {
    @if (!selectedLead()) {
    <div
      class="mb-4 shrink-0 p-4 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm">
      <div class="flex items-end justify-between flex-wrap gap-3">
        <div class="flex items-end gap-3">
          <div class="relative min-w-[200px] flex-1 md:flex-none">
            <label class="block mb-1 text-xs font-medium text-slate-400 dark:text-slate-500">Search</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                <app-icon-v2 name="search" [size]="18" />
              </div>
              <input type="text" [ngModel]="pendingSearchQuery()" (ngModelChange)="onSearchQueryChange($event)"
                placeholder="Search leads..."
                class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500" />
            </div>
          </div>
          <div class="min-w-[180px] shrink-0 relative z-40">
            <app-selection mode="date-picker" label="Start date"
              labelClass="!text-xs !text-slate-400 dark:!text-slate-500" datePlaceholder="Select start date"
              [ngModel]="pendingStartDate()" [minDate]="minFilterDate" [maxDate]="maxFilterDate"
              [enableYearMonthPicker]="true" [disableFutureDates]="true" [fullWidth]="true" containerClass="w-[180px]"
              (valueChange)="onPendingStartDateChange($event)" />
          </div>
          <div class="min-w-[180px] shrink-0 relative z-40">
            <app-selection mode="date-picker" label="End date" labelClass="!text-xs !text-slate-400 dark:!text-slate-500"
              datePlaceholder="Select end date" [ngModel]="pendingEndDate()" [minDate]="endDateMinFilter()"
              [maxDate]="maxFilterDate" [enableYearMonthPicker]="true" [disableFutureDates]="true" [fullWidth]="true"
              containerClass="w-[180px]" (valueChange)="onPendingEndDateChange($event)" />
          </div>
          <div class="min-w-[180px] shrink-0 relative z-40">
            <label class="block mb-1 text-xs font-medium text-slate-400 dark:text-slate-500">Status</label>
            <app-dropdown [options]="statusFilterOptions" [selectedValue]="pendingStatusFilter()" selectionMode="single"
              placeholder="All" variant="themeBase" [fullWidth]="true" size="md" menuClass="!z-[200] shadow-xl"
              containerClass="w-[180px]" (selectionChange)="onPendingStatusChange($event)" />
          </div>
          <app-toggle 
              [checked]="pendingIsTest()" 
              [label]="'Dummy'" 
              (toggleChange)="onPendingDummyToggleChange($event)" 
              [size]="'sm'"
              class="inline-flex h-9 items-center ml-2">
          </app-toggle>
        </div>
        <div class="flex items-end gap-3">
          <button type="button" (click)="applyFilters()" [disabled]="isLoading()"
            class="px-4 py-2.5 rounded-xl bg-[#A446FF] text-white text-sm font-bold hover:bg-[#9235FF] transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
            Apply
          </button>
          <button type="button" (click)="clearFilters()"
            class="px-4 py-2.5 rounded-xl bg-slate-100 dark:bg-slate-900 text-slate-700 dark:text-slate-300 text-sm font-bold hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors cursor-pointer">
            Clear
          </button>
        </div>
      </div>
    </div>
    <div
      class="bg-white dark:bg-slate-800 rounded-[32px] overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.02)] border border-white/50 dark:border-white/5 p-2">
      @if (isLoading()) {
      <div class="flex flex-col items-center justify-center min-h-[75vh] gap-4">
        <div class="w-10 h-10 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
        <p class="text-slate-600 dark:text-slate-400 font-bold animate-pulse">Fetching leads data...</p>
      </div>
      } @else if (error()) {
      <div class="flex flex-col items-center justify-center min-h-[75vh] gap-4 text-center px-6">
        <app-icon-v2 name="AlertCircle" [size]="48" customClass="text-red-400" />
        <div>
          <h3 class="text-xl font-bold text-slate-800 dark:text-slate-200 mb-2">Failed to Load</h3>
          <p class="text-slate-500 dark:text-slate-400">{{ error() }}</p>
        </div>
        <button (click)="fetchLeads()"
          class="px-5 py-2.5 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-xl transition-colors cursor-pointer">
          Retry
        </button>
      </div>
      } @else {
      <app-paginated-table [headers]="tableHeaders" [tableData]="filteredLeads()" [totalItems]="totalItems()"
        [currentPage]="currentPage()" [pageSize]="pageSize()" [serverSide]="serverSidePagination()"
        (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"
        [tableActionOptions]="tableActionOptions" (actionSelected)="onActionSelected($event)"
        headerClass="bg-slate-50/50 dark:bg-slate-900/50" tableWrapperClass="bg-transparent"
        className="min-h-[75vh]"></app-paginated-table>
      }
    </div>
    } @else {
    @let lead = selectedLead();
    <main class="w-full flex-1 min-h-0 flex flex-col xl:flex-row gap-4 xl:gap-6 items-start overflow-hidden">

      <!-- LEFT COLUMN: Call History -->
      <div class="w-full xl:w-[320px] shrink-0 flex flex-col h-[75vh] max-h-[75vh] overflow-y-auto">
        <nav
          class="flex items-center gap-2 text-sm font-bold text-slate-500 dark:text-slate-400 px-2 shrink-0 mb-3">
          <button (click)="backToList()"
            class="flex items-center gap-1.5 hover:text-purple-600 dark:hover:text-white transition-colors cursor-pointer">
            <app-icon-v2 name="ArrowLeft" [size]="16" />
            Leads
          </button>
          <app-icon-v2 name="chevronRight" [size]="16" class="text-slate-300 dark:text-slate-600"></app-icon-v2>
          <span class="text-slate-900 dark:text-white truncate" [title]="getLeadDisplayName(lead)">
            {{ getLeadDisplayName(lead) }}
          </span>
        </nav>
        <h2 class="text-lg font-bold text-[#141437] dark:text-white px-2 shrink-0 mb-3">Call History</h2>

        @if (conversations().length === 0) {
        <div
          class="bg-white dark:bg-surface-2 rounded-3xl p-8 text-center border border-slate-100 dark:border-white/5 shadow-sm">
          <app-icon-v2 name="Inbox" [size]="40" customClass="text-slate-300 mx-auto mb-2" />
          <p class="font-bold text-sm text-slate-700 dark:text-slate-300">No conversations</p>
        </div>
        } @else {
        <!-- Call List -->
        <div class="flex-1 min-h-0 overflow-y-auto pr-1 space-y-2">
          @for (conv of paginatedConversations(); track conv.conversationPid; let ci = $index) {
          <button (click)="selectConversationFromPage(ci)"
            class="w-full text-left bg-white dark:bg-surface-2 rounded-2xl border transition-all duration-300 group flex flex-col p-3 cursor-pointer"
            [ngClass]="isConversationActive(ci) ? 'border-[#A446FF] shadow-sm ring-1 ring-purple-500/20' : 'border-slate-100 dark:border-white/5 hover:border-purple-200 dark:hover:border-line-strong hover:shadow-sm'">
            <!-- Top Section -->
            <div class="flex items-start gap-2.5 w-full">
              <div class="w-8 h-8 shrink-0 rounded-lg flex items-center justify-center transition-colors"
                [ngClass]="isConversationActive(ci) ? 'bg-purple-100 text-[#A446FF] dark:bg-purple-900/40 dark:text-purple-300' : 'bg-slate-50 text-slate-400 dark:bg-slate-800 dark:text-slate-500 group-hover:text-[#A446FF]'">
                <app-icon-v2 name="headset" [size]="16"></app-icon-v2>
              </div>
              <div class="space-y-0.5 min-w-0 flex-1">
                <h3 class="text-[13px] font-bold truncate transition-colors"
                  [ngClass]="isConversationActive(ci) ? 'text-[#A446FF] dark:text-purple-300' : 'text-[#141437] dark:text-white group-hover:text-[#A446FF] dark:group-hover:text-white'"
                  [title]="'Call ' + (((conversationPage() - 1) * conversationPageSize) + ci + 1)">
                  {{ 'Call ' + (((conversationPage() - 1) * conversationPageSize) + ci + 1) }}
                </h3>
                <div class="text-[11px] text-slate-500 font-medium">
                  {{ conv.conversationStartTime | date:'MMM d, yyyy • h:mm a' }}
                </div>
              </div>
            </div>

            <!-- Bottom Section -->
            <div class="flex items-center justify-between gap-3 mt-2 pt-2 border-t border-slate-50 dark:border-white/5">
              <div class="flex flex-col gap-0 min-w-0">
                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Agent</span>
                <span class="text-[11px] font-bold text-slate-700 dark:text-slate-300 truncate"
                  [title]="conv.agentDetails?.name || 'No Agents'">
                  {{ conv.agentDetails?.name || 'No Agents' }}
                </span>
              </div>
            </div>
          </button>
          }
        </div>

        @if (conversationTotalPages() > 1) {
        <div class="shrink-0 pt-3 border-t border-slate-100 dark:border-slate-800">
          <app-pagination [currentPage]="conversationPage()" [pageSize]="conversationPageSize"
            [totalItems]="conversations().length" [paddingXAxis]="'px-0'" [paddingYAxis]="'py-0'" [forceStack]="true"
            (pageChange)="changeConversationPage($event)"></app-pagination>
        </div>
        }
        }
      </div>

      <!-- RIGHT COLUMN: Details & Context -->
      <div class="flex-1 min-w-0 flex flex-col h-[75vh] max-h-[75vh] overflow-y-auto">
        @if (conversations().length > 0) {
        @if (conversationView(); as vm) {
        <!-- Combined Header (Lead + Context) -->
        <div
          class="shrink-0 bg-gradient-to-br from-purple-50 via-white to-violet-50 dark:bg-none dark:bg-surface-2 rounded-2xl p-3 md:p-4 border border-purple-100/80 dark:border-white/5 shadow-sm mb-3">

          <div
            class="flex flex-wrap items-start justify-between gap-3 border-b border-purple-100/60 dark:border-slate-700/50 pb-3 mb-3">
            <div>
              <h2 class="text-lg md:text-xl font-bold text-[#141437] dark:text-white leading-tight">
                {{ getLeadDisplayName(lead) }}
              </h2>
              <div class="flex flex-wrap items-center gap-2 mt-1 text-xs text-slate-500 dark:text-slate-400">
                <!-- @if (lead.city) {
                          <span>{{ lead.city }}</span>
                        } -->
                @if (lead.industry) {
                <span>{{ lead.industry }}</span>
                }
                <span class="pl-2 border-l border-slate-200 dark:border-slate-700">{{
                  formatPlatformType(lead.platformType) }}</span>
                @if (lead.websiteUrl) {
                <a [href]="lead.websiteUrl" target="_blank" rel="noopener noreferrer"
                  class="pl-2 border-l border-slate-200 dark:border-slate-700 text-[#A446FF] dark:text-purple-400 hover:underline inline-block">
                  Website
                </a>
                }
              </div>
            </div>
            <span class="px-2 py-0.5 rounded-full text-[10px] font-bold uppercase"
              [ngClass]="lead.statusLabel_class || getStatusClass(lead.status)">
              {{ formatStatusLabel(lead.status) }}
            </span>
          </div>

          <!-- Context Details -->
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            <!-- Agent -->
            <div class="flex items-center gap-2 p-2 rounded-xl bg-white/60 dark:bg-slate-900/40">
              <div
                class="w-8 h-8 rounded-full bg-[#141437] flex items-center justify-center text-white text-[10px] font-bold">
                {{ getInitials(vm.agentName) }}
              </div>
              <div class="min-w-0">
                <p class="text-[9px] font-bold uppercase text-slate-400">Agent</p>
                <p class="text-xs font-bold text-slate-900 dark:text-white truncate"
                  [title]="vm.agentEmail || vm.agentName">{{ vm.agentName }}</p>
              </div>
            </div>

            <!-- Verdict -->
            <div class="flex items-center gap-2 p-2 rounded-xl bg-white/60 dark:bg-slate-900/40">
              <div
                class="w-8 h-8 rounded-full bg-purple-100 dark:bg-purple-900/40 flex items-center justify-center text-[#A446FF] dark:text-purple-300">
                <app-icon-v2 name="circlecheck" [size]="16" />
              </div>
              <div class="min-w-0">
                <p class="text-[9px] font-bold uppercase text-slate-400">Verdict</p>
                <div class="flex items-center gap-1">
                  <p class="text-xs font-bold text-slate-900 dark:text-white truncate" [title]="vm.verdict.label">{{
                    vm.verdict.label }}</p>
                </div>
              </div>
            </div>

            <!-- Tokens / Messages -->
            <div class="flex items-center gap-2 p-2 rounded-xl bg-white/60 dark:bg-slate-900/40">
              <div
                class="w-8 h-8 rounded-full bg-emerald-100 dark:bg-emerald-900/40 flex items-center justify-center text-emerald-600 dark:text-emerald-300">
                <app-icon-v2 name="Coins" [size]="16" />
              </div>
              <div class="min-w-0">
                <p class="text-[9px] font-bold uppercase text-slate-400">Usage</p>
                <p class="text-xs font-bold text-slate-900 dark:text-white truncate">
                  @if(vm.costing; as costing) {
                  @if (costing.displayCost) {
                  {{ costing.displayCost }}
                  } @else {
                  {{ costing.tokens !== null && costing.tokens !== undefined ? (costing.tokens | number) + ' tokens' :
                  'N.A.' }}
                  }
                  } @else {
                  N.A.
                  }
                </p>
              </div>
            </div>

            <!-- Score -->
            <div class="flex items-center gap-2 p-2 rounded-xl bg-white/60 dark:bg-slate-900/40">
              @if (vm.finalSummary.weightedScore) {
              <div class="w-8 h-8 rounded-lg text-white flex flex-col items-center justify-center shadow-sm"
                [ngClass]="scoreColor(vm.finalSummary.weightedScore)">
                <span class="text-xs font-bold leading-none">{{ vm.finalSummary.weightedScore }}</span>
              </div>
              <div class="min-w-0">
                <p class="text-[9px] font-bold uppercase text-slate-400">Call Score</p>
                <p class="text-xs font-bold text-slate-900 dark:text-white truncate"
                  [ngClass]="scoreTextColor(vm.finalSummary.weightedScore)">{{ vm.finalSummary.weightedScore >= 80 ?
                  'Excellent' : vm.finalSummary.weightedScore >= 50 ? 'Average' : 'Needs Work' }}</p>
              </div>
              } @else {
              <div
                class="w-8 h-8 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-400">
                <app-icon-v2 name="Activity" [size]="16" />
              </div>
              <div class="min-w-0">
                <p class="text-[9px] font-bold uppercase text-slate-400">Call Score</p>
                <p class="text-xs font-bold text-slate-900 dark:text-white truncate">N.A.</p>
              </div>
              }
            </div>
          </div>
        </div>

        <!-- Tabs Navigation -->
        <div class="shrink-0 flex gap-6 overflow-x-auto border-b border-slate-200/80 dark:border-slate-800/80">
          <button type="button"
            class="shrink-0 px-1 py-2.5 text-xs font-semibold border-b-2 transition-all duration-300 ease-out cursor-pointer"
            [ngClass]="activeDetailSection() === 'recording'
                      ? 'border-[#A446FF] text-[#A446FF] dark:text-purple-300'
                      : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:border-slate-300 dark:hover:border-slate-600'"
            (click)="selectDetailSection('recording')">
            Recording
          </button>
          <button type="button"
            class="shrink-0 px-1 py-2.5 text-xs font-semibold border-b-2 transition-all duration-300 ease-out cursor-pointer"
            [ngClass]="activeDetailSection() === 'summary'
                      ? 'border-[#A446FF] text-[#A446FF] dark:text-purple-300'
                      : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:border-slate-300 dark:hover:border-slate-600'"
            (click)="selectDetailSection('summary')">
            Summary
          </button>
          <button type="button"
            class="shrink-0 px-1 py-2.5 text-xs font-semibold border-b-2 transition-all duration-300 ease-out cursor-pointer"
            [ngClass]="activeDetailSection() === 'insights'
                      ? 'border-[#A446FF] text-[#A446FF] dark:text-purple-300'
                      : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:border-slate-300 dark:hover:border-slate-600'"
            (click)="selectDetailSection('insights')">
            Costing
          </button>
          <button type="button"
            class="shrink-0 px-1 py-2.5 text-xs font-semibold border-b-2 transition-all duration-300 ease-out cursor-pointer"
            [ngClass]="activeDetailSection() === 'audit'
                      ? 'border-[#A446FF] text-[#A446FF] dark:text-purple-300'
                      : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:border-slate-300 dark:hover:border-slate-600'"
            (click)="selectDetailSection('audit')">
            Audit
          </button>
        </div>

        <!-- Tab Content Sections -->
        <div class="flex-1 min-h-0 flex flex-col overflow-hidden bg-white/95 dark:bg-slate-950/90">
          @if (activeDetailSection() === 'recording') {
          <div class="h-full min-h-0 flex flex-col" [ngClass]="tabAnimationClass()">
            <div class="shrink-0 px-4 py-3 flex flex-col md:flex-row md:items-center justify-between gap-3">
              <div>
                <p class="text-base font-bold text-slate-900 dark:text-white">Recording & transcript</p>
                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                  @if (vm.recording) {
                  Audio playback syncs with highlighted transcript messages.
                  } @else {
                  Transcript is available, but no recording URL was returned.
                  }
                </p>
              </div>
              <div class="flex flex-wrap items-center gap-2">
                <span class="text-xs font-bold text-slate-500 mr-2">{{ vm.formattedTranscript.length }} messages</span>
                <button type="button" (click)="isFullTranscriptModalOpen.set(true)"
                  class="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-900 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors cursor-pointer">
                  View full transcript
                </button>
                <button type="button" (click)="downloadTranscript()"
                  class="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-900 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors cursor-pointer"
                  title="Download Transcript">
                  <div class="flex items-center gap-1.5"><app-icon-v2 name="Download" [size]="14"></app-icon-v2>
                    Download</div>
                </button>
              </div>
            </div>
            <div class="flex-1 min-h-0">
              <app-call-transcription class="h-full block" [messages]="vm.formattedTranscript"
                [isChatView]="!vm.recording" [productName]="lead.productName || lead.productKeyname || ''"
                [meetingUrl]="vm.recording?.referer || 'Call Recording'"
                [dateTime]="vm.conversationStartTime ? ((vm.conversationStartTime | date:'MMM d, yyyy • h:mm a') || '') : ''"
                [agents]="vm.agentName" [downloadTitle]="getTranscriptDownloadTitle(lead)"
                [downloadFileName]="getTranscriptDownloadFileName(lead)" [isPlaying]="isPlaying()" [isMuted]="isMuted()"
                [currentTime]="currentTime()" [audioDuration]="audioDuration()"
                [activeTranscriptIndex]="activeTranscriptIndex()" (togglePlay)="togglePlay()"
                (toggleMute)="toggleMute()" (seek)="seekTranscript($event)" (download)="downloadTranscript()"
                (stopPlayback)="stopPlayback()">
              </app-call-transcription>
            </div>
            @if (!vm.recording) {
            <div
              class="shrink-0 px-4 py-3 border-t border-slate-100 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-900/30">
              <p class="text-xs text-slate-500 dark:text-slate-400">
                Add an audio URL to the lead/conversation payload to enable playback and synced highlights.
              </p>
            </div>
            }
          </div>
          }

          @if (activeDetailSection() === 'summary') {
          <div class="h-full min-h-0 overflow-y-auto p-4" [ngClass]="tabAnimationClass()">
            @if (!vm.hasSummary || !vm.summaryLogView) {
            <div
              class="bg-white dark:bg-slate-800 rounded-3xl p-8 text-center border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)]">
              <p class="text-slate-500 dark:text-slate-400 font-medium">No summary data available for this conversation
                yet.</p>
            </div>
            } @else {
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 xl:gap-6">
              <div
                class="lg:col-span-2 bg-white dark:bg-slate-800 rounded-3xl p-6 border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)] space-y-6">
                <div class="flex items-center gap-4">
                  <h3 class="text-xl font-bold text-[#141437] dark:text-white flex-1">Call Summary</h3>
                </div>
                @if (vm.summaryLogView.managementSummary) {
                <div
                  class="p-5 bg-slate-50 dark:bg-slate-900/40 rounded-2xl border border-slate-100 dark:border-slate-700/50">
                  <p class="text-sm leading-relaxed text-slate-700 dark:text-slate-300">{{
                    vm.summaryLogView.managementSummary }}</p>
                </div>
                }
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
                  @if (vm.summaryLogView.highlights.length) {
                  <div
                    class="p-5 rounded-2xl bg-emerald-50/70 dark:bg-emerald-900/10 border border-emerald-100 dark:border-emerald-800/30 md:col-span-2 h-fit">
                    <p
                      class="text-xs font-bold uppercase tracking-wider text-emerald-700 dark:text-emerald-400 mb-3 flex items-center gap-2">
                      <app-icon-v2 name="TrendingUp" [size]="14"></app-icon-v2> Interest Signals
                    </p>
                    <ul class="space-y-2.5">
                      @for (h of vm.summaryLogView.highlights; track $index) {
                      <li class="text-sm text-emerald-900 dark:text-emerald-100/90 leading-snug flex items-start gap-2">
                        <span class="text-emerald-500 mt-0.5">•</span>
                        <span>{{ h }}</span>
                      </li>
                      }
                    </ul>
                  </div>
                  }
                  @if (vm.summaryLogView.callFlow.length) {
                  <div
                    class="p-5 rounded-2xl bg-slate-50 dark:bg-slate-900/40 border border-slate-100 dark:border-slate-700/50 h-fit self-start">
                    <p class="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-3">Call
                      Flow</p>
                    <div class="space-y-3">
                      @for (step of vm.summaryLogView.callFlow; track $index) {
                      <div>
                        @if (step.title) {
                        <p class="text-sm font-semibold text-slate-800 dark:text-slate-200">{{ step.title }}</p>
                        }
                        @if (step.summary) {
                        <p class="text-sm text-slate-600 dark:text-slate-400 mt-0.5 leading-relaxed">{{ step.summary }}
                        </p>
                        }
                      </div>
                      }
                    </div>
                  </div>
                  }
                  @if (vm.summaryLogView.majorIssues.length) {
                  <div
                    class="p-5 rounded-2xl bg-red-50/70 dark:bg-red-900/10 border border-red-100 dark:border-red-800/30 h-fit self-start">
                    <p
                      class="text-xs font-bold uppercase tracking-wider text-red-600 dark:text-red-400 mb-3 flex items-center gap-2">
                      <app-icon-v2 name="AlertTriangle" [size]="14"></app-icon-v2> Open Queries & Concerns
                    </p>
                    <ul class="space-y-2.5">
                      @for (issue of vm.summaryLogView.majorIssues; track $index) {
                      <li class="text-sm text-red-900 dark:text-red-100/90 leading-snug flex items-start gap-2">
                        <span class="text-red-500 mt-0.5">•</span>
                        <span>{{ issue }}</span>
                      </li>
                      }
                    </ul>
                  </div>
                  }
                </div>
              </div>
              <div class="space-y-4 xl:space-y-6">
                <div
                  class="bg-white dark:bg-slate-800 rounded-3xl p-5 md:p-6 border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)]">
                  <p class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2">Call Verdict</p>
                  <p class="text-lg font-bold text-[#141437] dark:text-white leading-snug">{{ vm.verdict.label }}</p>
                  @if (vm.verdict.reason) {
                  <p class="text-sm text-slate-600 dark:text-slate-400 mt-2 leading-relaxed">{{ vm.verdict.reason }}</p>
                  }
                </div>
                <!-- <div class="bg-white dark:bg-slate-800 rounded-3xl p-5 md:p-6 border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)]">
                            <p class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-4">Business Intelligence</p>
                            <div class="space-y-3.5 text-sm">
                              <div class="flex justify-between items-center"><span class="text-slate-500 font-medium">Interest Signal</span><span class="font-bold px-2 py-0.5 rounded-md" [ngClass]="vm.bizIntel.interestSignal ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300'">{{ vm.bizIntel.interestSignal ? 'Yes' : 'No' }}</span></div>
                              <div class="flex justify-between items-center"><span class="text-slate-500 font-medium">Demo Booked</span><span class="font-bold px-2 py-0.5 rounded-md" [ngClass]="vm.bizIntel.demoBooked ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300'">{{ vm.bizIntel.demoBooked ? 'Yes' : 'No' }}</span></div>
                              <div class="flex justify-between items-center"><span class="text-slate-500 font-medium">Follow-up Needed</span><span class="font-bold px-2 py-0.5 rounded-md" [ngClass]="vm.bizIntel.followUpRequested ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300'">{{ vm.bizIntel.followUpRequested ? 'Yes' : 'No' }}</span></div>
                              @if (vm.bizIntel.callOutcome) {
                                <div class="pt-3.5 border-t border-slate-100 dark:border-slate-700/50 mt-1">
                                  <p class="text-xs text-slate-500 mb-1">Outcome</p>
                                  <p class="text-sm font-semibold text-slate-800 dark:text-slate-200">{{ vm.bizIntel.callOutcome }}</p>
                                </div>
                              }
                            </div>
                          </div> -->
              </div>
            </div>
            }
          </div>
          }

          @if (activeDetailSection() === 'insights') {
          <div class="h-full min-h-0 overflow-y-auto p-4" [ngClass]="tabAnimationClass()">
            <div class="grid grid-cols-1 gap-4">
              <div
                class="bg-white dark:bg-slate-800 rounded-3xl p-6 border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)]">
                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                  <div>
                    <h3 class="text-lg font-bold text-[#141437] dark:text-white">Call Costing Data</h3>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Model, tokens, and financial metadata</p>
                  </div>
                  @if (vm.costing; as headerCosting) {
                  @if (headerCosting.displayCost) {
                  <div
                    class="px-5 py-3 rounded-2xl bg-gradient-to-br from-purple-600 to-indigo-600 text-white shadow-md shadow-purple-900/20 flex flex-col items-end">
                    <p class="text-2xl font-bold leading-none">{{ headerCosting.displayCost }}</p>
                    <p class="text-[10px] font-bold uppercase tracking-wider opacity-90 mt-1">Total {{
                      headerCosting.currency || 'Cost' }}</p>
                  </div>
                  }
                  }
                </div>

                @if (vm.costing; as costing) {
                <div class="space-y-6">
                  @if (costing.servicesWithPrices.length) {
                  <div>
                    <p class="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-4">Services With Prices
                    </p>
                    <div class="grid grid-cols-1 gap-4">
                      @for (service of costing.servicesWithPrices; track $index) {
                      <div
                        class="p-5 rounded-2xl bg-purple-50/60 border border-purple-100 dark:bg-purple-900/15 dark:border-purple-800/30">
                        <div class="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-4">
                          <div class="min-w-0 flex-1">
                            <span
                              class="text-[11px] font-bold uppercase tracking-wider text-purple-600 dark:text-purple-400 block mb-1">Service</span>
                            <p
                              class="text-sm font-semibold text-[#141437] dark:text-white leading-relaxed break-words">
                              {{ service.serviceName || 'Unknown service' }}</p>
                          </div>
                          @if (service.price) {
                          <div
                            class="shrink-0 px-4 py-2 rounded-xl bg-gradient-to-br from-purple-600 to-indigo-600 text-white shadow-sm">
                            <p class="text-lg font-bold leading-none">{{ service.price }}</p>
                          </div>
                          }
                        </div>
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                          @if (service.confidence) {
                          <div class="p-3 rounded-xl bg-white/70 dark:bg-slate-900/40 border border-purple-100/80 dark:border-purple-800/20">
                            <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1">Confidence</span>
                            <span class="font-semibold text-[#141437] dark:text-white capitalize">{{ service.confidence }}</span>
                          </div>
                          }
                          @if (service.pricePeriod) {
                          <div class="p-3 rounded-xl bg-white/70 dark:bg-slate-900/40 border border-purple-100/80 dark:border-purple-800/20">
                            <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1">Price Period</span>
                            <span class="font-semibold text-[#141437] dark:text-white capitalize">{{ service.pricePeriod }}</span>
                          </div>
                          }
                          @if (service.source) {
                          <div
                            class="sm:col-span-2 p-3 rounded-xl bg-white/70 dark:bg-slate-900/40 border border-purple-100/80 dark:border-purple-800/20">
                            <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1">Source</span>
                            <a [href]="service.source" target="_blank" rel="noopener noreferrer"
                              class="font-medium text-purple-700 dark:text-purple-300 break-all hover:underline">{{
                              service.source }}</a>
                          </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (costing.provider || costing.model || costing.tokens !== null) {
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    @if (costing.provider) {
                    <div
                      class="p-5 rounded-2xl bg-indigo-50/70 border border-indigo-100 dark:bg-indigo-900/20 dark:border-indigo-800/30">
                      <span
                        class="text-[11px] font-bold uppercase tracking-wider text-indigo-600 dark:text-indigo-400 block mb-1">Provider</span>
                      <span class="text-base font-bold text-indigo-950 dark:text-indigo-100 break-words">{{
                        costing.provider }}</span>
                    </div>
                    }
                    @if (costing.tokens !== null) {
                    <div
                      class="p-5 rounded-2xl bg-emerald-50/70 border border-emerald-100 dark:bg-emerald-900/20 dark:border-emerald-800/30">
                      <span
                        class="text-[11px] font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400 block mb-1">Tokens
                        Used</span>
                      <span class="text-base font-bold text-emerald-950 dark:text-emerald-100">{{ costing.tokens |
                        number }}</span>
                    </div>
                    }
                    @if (costing.model) {
                    <div
                      class="md:col-span-2 p-5 rounded-2xl bg-amber-50/70 border border-amber-100 dark:bg-amber-900/20 dark:border-amber-800/30">
                      <span
                        class="text-[11px] font-bold uppercase tracking-wider text-amber-600 dark:text-amber-400 block mb-2">Model
                        / Estimate</span>
                      <p
                        class="text-sm font-semibold text-amber-950 dark:text-amber-100 leading-relaxed whitespace-pre-wrap break-words">
                        {{ costing.model }}</p>
                    </div>
                    }
                  </div>
                  }

                  @if (costing.rows.length) {
                  <div class="mt-6 pt-6 border-t border-slate-100 dark:border-slate-700/50">
                    <p class="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-4">Detailed Metrics</p>
                    <div class="grid grid-cols-1 gap-3 text-sm">
                      @for (row of costing.rows; track row.label) {
                      <div
                        class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4 p-4 rounded-2xl bg-slate-50 dark:bg-slate-900/40 border border-slate-100 dark:border-slate-800">
                        <span class="text-slate-500 dark:text-slate-400 font-medium">{{ row.label }}</span>
                        <span
                          class="font-bold text-[#141437] dark:text-white leading-relaxed whitespace-pre-wrap break-words sm:text-right">{{
                          row.value }}</span>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
                } @else {
                <div
                  class="p-8 text-center bg-slate-50 dark:bg-slate-900/30 rounded-2xl border border-slate-100 dark:border-slate-800">
                  <p class="text-sm text-slate-500 dark:text-slate-400 font-medium">No costing data is available for
                    this call yet.</p>
                </div>
                }
              </div>
            </div>
          </div>
          }

          @if (activeDetailSection() === 'audit') {
          <div class="h-full min-h-0 overflow-y-auto p-4" [ngClass]="tabAnimationClass()">
            @if (!vm.hasAudit) {
            <div
              class="bg-white dark:bg-slate-800 rounded-3xl p-8 text-center border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)]">
              <p class="text-slate-500 dark:text-slate-400 font-medium">No audit report available for this conversation
                yet.</p>
            </div>
            } @else {
            <div class="flex justify-end mb-4">
              <button type="button" (click)="downloadReport()"
                class="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900/50 text-sm font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-900 transition-colors cursor-pointer border border-slate-200 dark:border-slate-700">
                <app-icon-v2 name="Download" [size]="16" />
                Download Report
              </button>
            </div>
            @if (auditCategories().length === 0) {
            <div
              class="bg-white dark:bg-slate-800 rounded-3xl p-8 text-center border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)]">
              <p class="text-slate-500 dark:text-slate-400 font-medium">No audit segment data available.</p>
            </div>
            } @else {
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 xl:gap-6">
              @for (cat of auditCategories(); track cat.id) {
              <div
                class="bg-white dark:bg-slate-800 rounded-3xl p-5 md:p-6 border border-slate-100 dark:border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.02)] flex flex-col h-full">
                <div class="flex items-start gap-4 mb-5">
                  <div
                    class="w-12 h-12 shrink-0 rounded-2xl flex items-center justify-center font-bold text-white text-lg shadow-md"
                    [ngClass]="scoreColor(cat.score, true)">{{ cat.score }}</div>
                  <div class="pt-1">
                    <h4 class="text-lg font-bold text-[#141437] dark:text-white leading-tight">{{ cat.title }}</h4>
                    @if (cat.justification) { <p
                      class="text-sm text-slate-500 dark:text-slate-400 mt-1.5 leading-relaxed">{{ cat.justification }}
                    </p> }
                  </div>
                </div>
                @if (cat.analysis) {
                <div
                  class="p-4 rounded-2xl bg-slate-50 dark:bg-slate-900/40 mb-5 border border-slate-100 dark:border-slate-700/50">
                  <p class="text-sm text-slate-700 dark:text-slate-300 leading-relaxed italic">"{{ cat.analysis }}"</p>
                </div>
                }
                <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-auto">
                  @if (cat.wentWell.length) {
                  <div
                    class="bg-emerald-50/50 dark:bg-emerald-900/10 p-4 rounded-2xl border border-emerald-100 dark:border-emerald-800/30">
                    <h5
                      class="text-[11px] font-bold uppercase tracking-wider text-emerald-700 dark:text-emerald-400 mb-3 flex items-center gap-1.5">
                      <app-icon-v2 name="ThumbsUp" [size]="14"></app-icon-v2> What went well</h5>
                    <ul class="space-y-2">
                      @for (item of cat.wentWell; track $index) {
                      <li class="text-sm text-emerald-900 dark:text-emerald-100/90 leading-snug flex items-start gap-2">
                        <span class="text-emerald-500 mt-0.5">•</span>
                        <span>{{ item }}</span>
                      </li>
                      }
                    </ul>
                  </div>
                  }
                  @if (cat.opportunities.length) {
                  <div
                    class="bg-amber-50/50 dark:bg-amber-900/10 p-4 rounded-2xl border border-amber-100 dark:border-amber-800/30">
                    <h5
                      class="text-[11px] font-bold uppercase tracking-wider text-amber-700 dark:text-amber-400 mb-3 flex items-center gap-1.5">
                      <app-icon-v2 name="TrendingUp" [size]="14"></app-icon-v2> Opportunities</h5>
                    <ul class="space-y-2">
                      @for (item of cat.opportunities; track $index) {
                      <li class="text-sm text-amber-900 dark:text-amber-100/90 leading-snug flex items-start gap-2">
                        <span class="text-amber-500 mt-0.5">•</span>
                        <span>{{ item }}</span>
                      </li>
                      }
                    </ul>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
            }
            }
          </div>
          }
        </div>
        }
        }
      </div>
    </main>
    }
    }
  </div>

  <!-- Complete Cheat Sheet Modal -->
  @if (isCheatSheetModalOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 md:p-6"
    (click)="isCheatSheetModalOpen.set(false)">
    <div
      class="bg-white dark:bg-surface-2 rounded-3xl w-full max-w-5xl h-[85vh] flex flex-col shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()">
      <div
        class="px-6 py-4 border-b border-slate-100 dark:border-white/5 flex items-center justify-between bg-slate-50/50 dark:bg-slate-900/30">
        <div>
          <h2 class="text-lg font-bold text-[#141437] dark:text-white">Complete Sales Cheat Sheet</h2>
          @if (selectedLead(); as lead) {
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">{{ getLeadDisplayName(lead) }}</p>
          }
        </div>
        <button (click)="isCheatSheetModalOpen.set(false)"
          class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors cursor-pointer">
          <app-icon-v2 name="X" [size]="24"></app-icon-v2>
        </button>
      </div>
      <div class="flex-1 overflow-y-auto p-5 md:p-6 bg-slate-50/60 dark:bg-slate-950/20">
        @if (conversationView(); as vm) {
        @if (vm.cheatSheet.length || vm.salesPitch.length) {
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          @if (vm.cheatSheet.length) {
          <section class="space-y-3">
            <div class="flex items-center justify-between">
              <p class="text-xs font-bold uppercase tracking-wider text-blue-600 dark:text-blue-300">Sales cheat sheet
              </p>
              <span
                class="px-2 py-1 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-200 text-[11px] font-bold">{{
                vm.cheatSheet.length }} sections</span>
            </div>
            @for (section of vm.cheatSheet; track section.title) {
            <div
              class="p-5 rounded-2xl bg-white text-slate-900 border border-blue-100 shadow-sm dark:bg-slate-900 dark:text-slate-100 dark:border-blue-900/60">
              <p class="text-sm font-bold text-blue-700 dark:text-blue-300 mb-3">{{ section.title }}</p>
              <markdown class="insight-markdown text-sm leading-relaxed" [data]="section.content"></markdown>
            </div>
            }
          </section>
          }
          @if (vm.salesPitch.length) {
          <section class="space-y-3">
            <div class="flex items-center justify-between">
              <p class="text-xs font-bold uppercase tracking-wider text-violet-600 dark:text-violet-300">L1 sales pitch
              </p>
              <span
                class="px-2 py-1 rounded-full bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-200 text-[11px] font-bold">{{
                vm.salesPitch.length }} sections</span>
            </div>
            @for (section of vm.salesPitch; track section.title) {
            <div
              class="p-5 rounded-2xl bg-white text-slate-900 border border-violet-100 shadow-sm dark:bg-slate-900 dark:text-slate-100 dark:border-violet-900/60">
              <p class="text-sm font-bold text-violet-700 dark:text-violet-300 mb-3">{{ section.title }}</p>
              <markdown class="insight-markdown text-sm leading-relaxed" [data]="section.content"></markdown>
            </div>
            }
          </section>
          }
        </div>
        } @else {
        <div class="h-full min-h-[300px] flex items-center justify-center text-center">
          <p class="text-sm text-slate-500 dark:text-slate-400">No cheat sheet or sales pitch data is available for this
            lead.</p>
        </div>
        }
        }
      </div>
    </div>
  </div>
  }
</div>

<!-- Full Transcript Modal -->
@if (isFullTranscriptModalOpen()) {
<div class="absolute inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 md:p-6 max-h-[calc(100vh-2rem)] rounded-2xl"
  (click)="isFullTranscriptModalOpen.set(false)">
  <div
    class="bg-white dark:bg-surface-2 rounded-3xl w-full max-w-4xl h-[85vh] max-h-[85vh] flex flex-col shadow-2xl overflow-hidden"
    (click)="$event.stopPropagation()">
    <div
      class="px-6 py-4 border-b border-slate-100 dark:border-white/5 flex items-center justify-between bg-slate-50/50 dark:bg-slate-900/30">
      <h2 class="text-lg font-bold text-[#141437] dark:text-white">Full Call Transcription</h2>
      <div class="flex items-center gap-4">
        <button (click)="isFullTranscriptModalOpen.set(false)"
          class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors">
          <app-icon-v2 name="X" [size]="24"></app-icon-v2>
        </button>
      </div>
    </div>
    <div class="flex-1 overflow-hidden">
      @if (conversationView(); as vm) {
      <app-call-transcription class="h-full block" [messages]="vm.formattedTranscript" [isChatView]="!vm.recording"
        [productName]="selectedLead()?.productName || selectedLead()?.productKeyname || ''"
        [meetingUrl]="vm.recording?.referer || 'Call Recording'"
        [dateTime]="vm.conversationStartTime ? ((vm.conversationStartTime | date:'MMM d, yyyy • h:mm a') || '') : ''"
        [agents]="vm.agentName"
        [downloadTitle]="selectedLead() ? getTranscriptDownloadTitle(selectedLead()) : 'Call Transcription'"
        [downloadFileName]="selectedLead() ? getTranscriptDownloadFileName(selectedLead()) : 'transcript.pdf'"
        [isPlaying]="isPlaying()" [isMuted]="isMuted()" [currentTime]="currentTime()"
        [audioDuration]="audioDuration()" [activeTranscriptIndex]="activeTranscriptIndex()"
        (togglePlay)="togglePlay()" (toggleMute)="toggleMute()" (seek)="seekTranscript($event)"
        (download)="downloadTranscript()" (stopPlayback)="stopPlayback()">
      </app-call-transcription>
      }
    </div>
  </div>
</div>
}
</div>
